import { Mail } from "@mui/icons-material";
import Logout from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import CommunicationPreferences from "./CommunicationPreferences"; // Import the new component
export default function ProfileButton() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const appVersion = process.env.REACT_APP_VERSION;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openModal, setOpenModal] = useState(false); // State to manage modal visibility
  const [preferences, setPreferences] = useState({
    whatsappOptIn: false,
    emailOptIn: false,
    smsOptIn: false,
  }); // State to hold communication preferences
  const [isFetched, setIsFetched] = useState(false); // To track if preferences have been fetched
  const user = JSON.parse(localStorage.getItem("user"));

  const backendUrl =
    process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

  const handleLogout = () => {
    logout();
    localStorage.setItem("hasSeenOffers", "false");
    localStorage.setItem("confettiShown", "false");
    navigate("/signin");
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null); // Close the menu
  };

  const handleOpenCommunicationPreferences = () => {
    setOpenModal(true); // Open the modal when clicked
    handleClose(); // Close the profile menu
  };

  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal
  };

  // Fetch communication preferences when the modal is opened and only once
  useEffect(() => {
    if (openModal && !isFetched) {
      const fetchCommunicationPreferences = async () => {
        try {
          const response = await axios.post(
            `${backendUrl}/api/user/get-communication-preferences`,
            { uuid: user.uuid },
            {
              headers: { "x-api-key": process.env.REACT_APP_BACKEND_API_KEY },
            }
          );
          setPreferences(response.data); // Update the state with the fetched preferences
          setIsFetched(true); // Set the flag to prevent further fetching
        } catch (error) {
          console.error("Error fetching communication preferences:", error);
        }
      };

      fetchCommunicationPreferences();
    }
  }, [openModal, isFetched, user]); // We add isFetched as a dependency to avoid refetching

  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Typography
          sx={{
            minWidth: 100,
            display: { xs: "none", sm: "none", md: "block" },
            cursor: "pointer",
          }}
          onClick={handleClick}
        >
          Welcome, <strong>{user.firstName}</strong>
        </Typography>
        <Tooltip title="Menu">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{
              ml: 2,
              mr: { lg: 4 },
              backgroundColor: {
                xs: "rgba(255,255,255,0.1)",
                lg: "rgba(0,0,0,0.02)",
              },
              color: {
                xs: "#fff",
                lg: "#20ae94",
              }
            }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <MenuIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose} // Close the menu when clicking on the menu items
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleOpenCommunicationPreferences}>
          {/* Trigger modal here */}
          <ListItemIcon>
            <Mail fontSize="small" />
          </ListItemIcon>
          Communication Preferences
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
        <Divider />
        <MenuItem
          className="Mui-disabled MuiMenuItem-dense"
          sx={{ fontSize: 12 }}
        >
          v{appVersion}
        </MenuItem>
      </Menu>

      {/* Communication Preferences Modal */}
      <CommunicationPreferences
        open={openModal}
        handleClose={handleCloseModal}
        preferences={preferences} // Pass preferences to the modal
      />
    </React.Fragment>
  );
}
